import type { TermMonthItem } from '@makemydeal/dr-platform-types';
import { useHasCalculatedColumn } from './hooks/useIsColumnCalculated';
import TermMonthInput from './TermMonthInput';

interface ITermProps {
    paymentGridTermList: TermMonthItem[];
    isLoading?: boolean;
}

const TermsMonthRow = ({ paymentGridTermList, isLoading = false }: ITermProps) => {
    const hasCalculatedColumn = useHasCalculatedColumn(paymentGridTermList, isLoading);

    return (
        <>
            {paymentGridTermList.map((term) => (
                <TermMonthInput
                    key={`${term.key}-${term.val}`}
                    term={term}
                    isLoading={isLoading}
                    hasCalculatedColumn={hasCalculatedColumn}
                />
            ))}
        </>
    );
};

export default TermsMonthRow;
